import React, { useEffect, useState } from "react";
import Styles from "./SearchpageStyles.module.css";
import RenegerateBox from "./RenegerateBox";
import { useSelector } from "react-redux";
import { Avatar } from "antd";
import ExpertData from "./ExpertData";
import DocData from "./DocData";

export default function Tabs() {
  const searchState = useSelector((state) => state.search);
  const [similarData, setSimilarData] = useState([...searchState.expertData, ...searchState.docData]);
  const  [isDisable, setDisable]= useState(searchState.origSearchData.filter((obj) => {
    if (obj.confidence) {
      return obj;
    }
  }));
  const onClickRegen=(val)=>{
    if(isDisable.length===0) return;
    setVal(val);
  }
  const [val, setVal] = useState(
    searchState.origSearchData.filter((obj) => {
      if (obj.confidence) {
        return obj;
      }
    }).length === 0
      ? 2
      : 1
  );
  useEffect(()=>{
    setSimilarData([...searchState.expertData,...searchState.docData]);
  },[searchState.docData])
  return (
    <>
      <div className="mt-4 mb-5">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            className={val === 1 ? Styles.onSelectedtab : Styles.ohHovertab}
            onClick={() => onClickRegen(1)}
            style={{cursor:`${isDisable.length===0?'no-drop':'pointer'}`}}
          >
            Answer Sources&nbsp;<Avatar className={Styles.numberAvatar} >{searchState.origRawSearchedData.length}</Avatar>
          </div>
          <div
            className={val === 2 ? Styles.onSelectedtab : Styles.ohHovertab}
            onClick={() => setVal(2)}
          >
            Related Topics&nbsp;<Avatar className={Styles.numberAvatar} >{similarData.filter(que=>!que.confidence).length}</Avatar>
          </div>
          {/* <div
            className={val === 3 ? Styles.onSelectedtab : Styles.ohHovertab}
            onClick={() => setVal(3)}
          >
            File Sources&nbsp;<Avatar className={Styles.numberAvatar}>{searchState.docData.filter(que=>!que.confidence).length}</Avatar>
          </div> */}
        </div>
        {val === 1 && <RenegerateBox />}
        {val === 2 && <ExpertData data={similarData} />}
        {/* {val === 3 && <DocData data={searchState.docData} />} */}
      </div>
    </>
  );
}
